import { isUserAuthenticated } from "@/middleware/auth";
import {
  SocketEventActionType,
  //  ReactionEventType,
  Umbra_ReactionEventType,
} from "./types";
import { updateMessageByServerIdInLocalDB } from "@/indexedDB/services/messages";
// import { updateMessageOnReactionEvent } from "@/middleware/messages";
import { queryClient } from "@/queryClient";

/**
 * Handles reaction events from the socket
 *
 * @param data - The reaction event data containing action and reaction information
 */
// export const handleReactionEvent = async (
//   data: ReactionEventType,
// ): Promise<void> => {
//   try {
//     const { reaction } = data;

//     // Update the message in local database when reaction event is received
//     await updateMessageOnReactionEvent(reaction.message_id);
//   } catch (error) {
//     // eslint-disable-next-line no-console
//     console.error("Error handling reaction event:", error);
//   }
// };

export const umbra_handleReactionEvent = async (
  data: Umbra_ReactionEventType,
): Promise<void> => {
  const userFingerPrint = isUserAuthenticated();
  if (!userFingerPrint) {
    return;
  }

  switch (data.action) {
    case SocketEventActionType.CREATE:
      await onAddReaction({ eventPayload: data });
      break;
    case SocketEventActionType.DELETE:
      await onDeleteReaction({ eventPayload: data });
      break;
    default:
      break;
  }
};

const onAddReaction = async ({
  eventPayload,
}: {
  eventPayload: Umbra_ReactionEventType;
}) => {
  await updateMessageByServerIdInLocalDB(eventPayload.reaction.message_id, {
    reactions: eventPayload.reaction.summary,
  });

  // invalidate the query - all reactions
  queryClient.invalidateQueries({
    queryKey: [
      "message-reactions",
      eventPayload.reaction.chat_id,
      eventPayload.reaction.message_id,
    ],
  });

  // invalidate the query - all reactions by emoji string
  queryClient.invalidateQueries({
    queryKey: [
      "message-reactions",
      eventPayload.reaction.chat_id,
      eventPayload.reaction.message_id,
      eventPayload.reaction.reaction,
    ],
  });
};

const onDeleteReaction = async ({
  eventPayload,
}: {
  eventPayload: Umbra_ReactionEventType;
}) => {
  await updateMessageByServerIdInLocalDB(eventPayload.reaction.message_id, {
    reactions: eventPayload.reaction.summary,
  });

  // invalidate the query - all reactions
  queryClient.invalidateQueries({
    queryKey: [
      "message-reactions",
      eventPayload.reaction.chat_id,
      eventPayload.reaction.message_id,
    ],
  });

  // invalidate the query - all reactions by emoji string
  queryClient.invalidateQueries({
    queryKey: [
      "message-reactions",
      eventPayload.reaction.chat_id,
      eventPayload.reaction.message_id,
      eventPayload.reaction.reaction,
    ],
  });
};
